import { render, staticRenderFns } from "./CodeActive.vue?vue&type=template&id=3a73f9e8&scoped=true"
import script from "./CodeActive.vue?vue&type=script&lang=js"
export * from "./CodeActive.vue?vue&type=script&lang=js"
import style0 from "./CodeActive.vue?vue&type=style&index=0&id=3a73f9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a73f9e8",
  null
  
)

export default component.exports